<script>
  import { afterUpdate } from "svelte"
  import LocationCard from "../../SinDocAnalytics/Components/locationCard.svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"

  export let json

  $: location = json.location ? JSON.parse(json.location) : ""

  let IPDetails = false

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<a href="#/analytics/documents/single?id={json.doc}" target="_blank" class="flex w-full cursor-pointer items-center justify-between gap-3 rounded-md bg-[#f7f7f7] p-3 text-gray-200 hover:shadow-md dark:border-2 dark:border-transparent dark:bg-lightgray dark:hover:border-blue-500">
  <!-- <a href="#/analytics/documents?id={json.doc}" class="flex w-full cursor-pointer items-center justify-between gap-3 rounded-md bg-[#f7f7f7] p-3 text-gray-200 dark:bg-darkgray"> -->
  <div class="flex w-full items-center gap-5">
    <div class="flex w-full flex-col gap-2">
      <button class="w-full text-start font-mono text-xs font-semibold text-black hover:text-blue-500 active:text-blue-500 dark:text-white dark:hover:text-blue-500 dark:active:text-blue-500 sm:text-base">{json.doc}</button>
      <p class="w-full select-none text-xs font-normal text-gray-200 md:text-sm">
        <i class="fa-solid fa-calendar-days" />
        &nbsp;&nbsp;{new Date(json.date).toString().slice(0, 24)}
      </p>
    </div>
    <div class="flex w-full items-center gap-5">
      {#if location.city}
        <div class="hidden items-center gap-1.5 px-1.5 text-sm font-medium text-gray-500 md:flex">
          {#if location.countryCode}
            <span class="flag flag-{location.countryCode.toLowerCase()} overflow-hidden" />
          {:else}
            <i class="fa-solid fa-earth-americas" />
          {/if}
          <span class="w-28 truncate text-xs hover:text-blue-500 sm:text-base">{location.country}</span>
        </div>
        <div class="hidden items-center gap-1.5 px-1.5 text-sm font-medium text-gray-500 lg:flex">
          <i class="fa-solid fa-city" />
          <span class="w-28 truncate text-xs hover:text-blue-500 sm:text-base">{location.city}</span>
        </div>
      {/if}
    </div>
    <div class="">
      <button name="tooltip" id="Location Info" tooltip-position="top" on:click|stopPropagation|preventDefault={() => (IPDetails = true)} class="flex cursor-pointer items-center gap-1 rounded-full px-2.5 py-2 text-sm text-yellow-500 hover:bg-yellow-500 hover:text-white active:bg-yellow-600 xl:px-5">
        <i class="fa-solid fa-circle-info" />
        <p class="hidden w-max lg:block">Location Info</p>
      </button>
    </div>
  </div>
</a>
{#if IPDetails}
  <LocationCard {json} {location} on:click={() => (IPDetails = false)} />
{/if}
